
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import Text from '../../common/client/components/Text';

import theme from './theme';

const classNames = mergeStyleSets({
    root: {
        paddingBottom: 8
    }
});

const PanelTitle = ({title}) => {
    return (
        <div className={classNames.root}>
            <Text large bold color={theme.fabricTheme.palette.neutralTertiary}>{title}</Text>
        </div>
    )
};

export default PanelTitle;
